// Import general mixin for shared functionality.
import defaultApp from './defaultApp.js';

// Import components for this specific app.
import listItem from './components/ListItem.vue';

const partnersApp = {
    ...defaultApp,
    // Overwrite default app functionalities as you please by using the spread operator.
    components: {
        ...defaultApp.components,
        listItem
    }
};

export default partnersApp;
